// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#barContainer {
  position: absolute;
  bottom: 5vh;
  right: 5px;
  width: 30px;
  height: 95%;
  background-color: #d8d8d8;
  border-radius: 5px;
  border: 1px solid black;
  /* z-index: 1000; */
}

#progressBar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #00ff00;
  border-radius: 5px;
  /* z-index: 1000; */
}
`, "",{"version":3,"sources":["webpack://./components/css/progressBar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":["#barContainer {\n  position: absolute;\n  bottom: 5vh;\n  right: 5px;\n  width: 30px;\n  height: 95%;\n  background-color: #d8d8d8;\n  border-radius: 5px;\n  border: 1px solid black;\n  /* z-index: 1000; */\n}\n\n#progressBar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #00ff00;\n  border-radius: 5px;\n  /* z-index: 1000; */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
